import DrugDetailOption from "./DrugDetailOption";

export default DrugDetailOption;